import { PAGE_TYPE_ENUM } from "@shared/types";
import ProductDetails from "components/ProductDetails/ProductDetails";
import PageLayout from "components/layout/PageLayout";
import { setDYContext } from "config";
import { useLogContext } from "context/log";
import { generatePageId } from "helpers/analyticsLogger";
import { FC, useEffect } from "react";
import { ProductBySlugQuery } from "services/datocms/generated";

interface ProductDetailsPageProps {
  datoProduct: ProductBySlugQuery["product"] | null;
}

const ProductDetailPage: FC<ProductDetailsPageProps> = ({ datoProduct }) => {
  const { useLogPageView } = useLogContext();

  useLogPageView({
    pageType: PAGE_TYPE_ENUM.product,
    id: generatePageId("product"),
  });

  useEffect(() => {
    if (datoProduct?.gtin) {
      setDYContext("PRODUCT", [datoProduct?.gtin || ""]);
    }
  }, [datoProduct?.gtin]);

  return (
    <PageLayout seo={datoProduct?.seo}>
      <ProductDetails datoProduct={datoProduct} />
    </PageLayout>
  );
};

export default ProductDetailPage;
